import { render, staticRenderFns } from "./myDetails.vue?vue&type=template&id=6218fe64&scoped=true"
import script from "./myDetails.vue?vue&type=script&lang=js"
export * from "./myDetails.vue?vue&type=script&lang=js"
import style0 from "./myDetails.vue?vue&type=style&index=0&id=6218fe64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6218fe64",
  null
  
)

export default component.exports